import React from 'react';
import { makeStyles, Icon, Tooltip } from '~/lib/bn-material-ui';
import { getOrderStateText } from './order-state-text';
import { OrderIcon } from './order-icon';
import { isOrderLate } from '~/orders/order-helpers';

const useStyles = makeStyles(() => {
  return {
    statusIcons: {
      fontSize: '1em',
      marginRight: '.5em',
    },
    approved: {
      fontSize: '1em',
      marginLeft: '1em',
    },
  };
});

export function OrderState({ orderEntity }) {
  const styles = useStyles();
  const { state, acknowledgement } = orderEntity?.properties || {};
  const isLate = isOrderLate(orderEntity);
  const stateText = getOrderStateText({ state, isLate, acknowledgement });

  return (<>
    <OrderIcon orderEntity={orderEntity} className={styles.statusIcons} />
    {stateText === 'Missed Del.' ? (
      <Tooltip title='Missed Delivery'><div>{stateText}</div></Tooltip>
    ) : (stateText)}
    <AcknowledgementCheck orderEntity={orderEntity} styles={styles} />
  </>);
}

function AcknowledgementCheck({ orderEntity, styles }) {
  const { state, acknowledgement } = orderEntity?.properties || {};
  const isApproved = acknowledgement === 'approved' && state === 'scheduled';

  if (!isApproved) {
    return null;
  }

  return (
    <Tooltip placement='right' arrow title='Order acknowledged'>
      <Icon className={`${styles.approved} fas fa-check-circle`} />
    </Tooltip>
  );
}
